<template>
    <div class="modal fade" tabindex="-1" ref="modalRisco" id="ModalRisco">
        <div class="modal-dialog modal-lg modal-dialog-centered">
            <div class="modal-content border-0 modal-risco">
                <div class="modal-body modal-risco-body">
                    <h3 class="title modal-risco-title m-0 d-flex align-items-center gap-2">
                        <i class="bi bi-clipboard2-pulse"></i>
                        Registro de Risco
                    </h3>
                    <hr class="modal-risco-divider" />
                    <div class="row">
                        <div class="form-group mb-3 col-md-6">
                            <label for="categoria" class="form-label">Categoria</label>
                            <select v-model="categoriaSelecionada" class="form-control" :class="{ 'border-danger': camposInvalidos.categoriaSelecionada }" id="categoria">
                                <option disabled value="">Selecione:</option>
                                <option v-for="cat in categorias" :key="cat.idRiscoCategoria" :value="cat.idRiscoCategoria">
                                    {{ cat.nmCategoria }}
                                </option>
                            </select>
                        </div>
                        <div class="mb-3 col-md-6">
                            <label for="titulo" class="form-label">Título do Risco</label>
                            <input type="text" v-model="tituloRisco" class="form-control" :class="{ 'border-danger': camposInvalidos.tituloRisco }" id="titulo" placeholder="Digite o título do risco" />
                        </div>
                    </div>
                    <div class="row">
                        <div class="form-group mb-3 col-md-12">
                            <label for="descricao" class="form-label">Descrição do Risco</label>
                            <input tpe="text" v-model="descricaoRisco" class="form-control" id="descricao" placeholder="Digite a descrição do risco" />
                        </div>
                    </div>
                    <div class="row">
                        <div class="form-group mb-3 col-md-4">
                            <label for="probabilidade" class="form-label">Probabilidade</label>
                            <select v-model="prob" class="form-control" :class="{ 'border-danger': camposInvalidos.prob }" id="probabilidade">
                                <option disabled value="">Selecione:</option>
                                <option v-for="escala in escalas" :key="escala.idEscala" :value="escala.idEscala">
                                    {{ escala.nmEscala }}
                                </option>
                            </select>
                        </div>
                        <div class="form-group mb-3 col-md-4">
                            <label for="impacto" class="form-label">Impacto</label>
                            <select v-model="quali" class="form-control" :class="{ 'border-danger': camposInvalidos.quali }" id="impacto">
                                <option disabled value="">Selecione:</option>
                                <option v-for="escala in escalas" :key="escala.idEscala" :value="escala.idEscala">
                                    {{ escala.nmEscala }}
                                </option>
                            </select>
                        </div>
                        <div class="form-group mb-3 col-md-4">
                            <label for="impactoFinanceiro" class="form-label">Impacto Financeiro</label>
                            <select v-model="quanti" class="form-control" :class="{ 'border-danger': camposInvalidos.quanti }" id="impactoFinanceiro">
                                <option disabled value="">Selecione:</option>
                                <option v-for="escala in escalas" :key="escala.idEscala" :value="escala.idEscala">
                                    {{ escala.nmEscala }}
                                </option>
                            </select>
                        </div>
                    </div>
                    <div class="row">
                        <!-- Causa e Consequência -->
                        <div class="form-group mb-0">
                            <label class="form-label d-block">Adicionar Causa ou Consequência</label>
                            <div class="d-flex align-items-center gap-2 mb-3">
                                <div class="btn-group toggle-selector" role="group">
                                    <button type="button"
                                            :class="['btn', tipoCausaConseq === 'CA' ? 'btn-primary' : 'btn-outline-secondary']"
                                            @click="tipoCausaConseq = 'CA'">
                                        Causa
                                    </button>
                                    <button type="button"
                                            :class="['btn', tipoCausaConseq === 'CO' ? 'btn-primary' : 'btn-outline-secondary']"
                                            @click="tipoCausaConseq = 'CO'">
                                        Consequência
                                    </button>
                                </div>
                                <input type="text" v-model="novaCausaConseq" class="form-control" placeholder="Descreva aqui..." />
                                <button class="btn btn-success" @click="adicionarCausaConseq">Incluir</button>
                            </div>
                        </div>
                        <div v-if="todasCausasConsequencias.length > 0" class="table-container">
                            <div class="table-wrapper mb-3">
                                <table class="custom-table">
                                    <thead>
                                        <tr>
                                            <th class="text-center" style="width: 150px;">Tipo</th>
                                            <th>Descrição</th>
                                            <th class="text-center" style="width: 1%;"> Ações</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(item, index) in todasCausasConsequencias" :key="index">
                                            <td>
                                                <div v-if="editandoIndex === index" class="text-center">
                                                    <div class="btn-group toggle-selector" role="group">
                                                        <button type="button"
                                                                :class="['btn btn-sm', editandoTipo === 'CA' ? 'btn-primary' : 'btn-outline-secondary']"
                                                                @click="editandoTipo = 'CA'">
                                                            Causa
                                                        </button>
                                                        <button type="button"
                                                                :class="['btn btn-sm', editandoTipo === 'CO' ? 'btn-primary' : 'btn-outline-secondary']"
                                                                @click="editandoTipo = 'CO'">
                                                            Consequência
                                                        </button>
                                                    </div>
                                                </div>
                                                <div v-else class="text-center">
                                                    {{ item.tpRiscoCausaConsequencia === 'CA' ? 'Causa' : 'Consequência' }}
                                                </div>
                                            </td>
                                            <td>
                                                <div v-if="editandoIndex === index">
                                                    <input type="text" class="form-control form-control-sm" v-model="editandoDescricao" />
                                                </div>
                                                <div v-else>
                                                    {{ item.nmRiscoCausaConsequencia }}
                                                </div>
                                            </td>
                                            <td class="text-center" style="white-space: nowrap;">
                                                <div v-if="editandoIndex === index">
                                                    <button class="btn btn-acao btn-acao-success btn-sm" @click="salvarEdicao(index)" title="Salvar">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check-lg" viewBox="0 0 16 16">
                                                            <path d="M13.485 1.529a.75.75 0 0 1 .03 1.057l-7.25 8a.75.75 0 0 1-1.079.02l-3.25-3.5a.75.75 0 1 1 1.098-1.022l2.678 2.886 6.72-7.416a.75.75 0 0 1 1.053-.025z" />
                                                        </svg>
                                                    </button>
                                                </div>
                                                <div v-else>
                                                    <button class="btn btn-acao btn-acao-primary btn-sm me-2"
                                                            @click="editarCausaConseq(index)"
                                                            title="Editar">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-pencil-fill" viewBox="0 0 16 16">
                                                            <path d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708z" />
                                                            <path d="M13.5 6.207 9.793 2.5 2 10.293V13.5a.5.5 0 0 0 .5.5h3.207z" />
                                                        </svg>
                                                    </button>
                                                    <button class="btn btn-acao btn-acao-danger btn-sm"
                                                            @click="removerCausaConseq(index)"
                                                            title="Excluir">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-trash3-fill" viewBox="0 0 16 16">
                                                            <path d="M11 1.5v1h3.5a.5.5 0 0 1 0 1h-.538l-.853 10.66A2 2 0 0 1 11.115 16h-6.23a2 2 0 0 1-1.994-1.84L2.538 3.5H2a.5.5 0 0 1 0-1H5.5v-1A1.5 1.5 0 0 1 7 0h2a1.5 1.5 0 0 1 1.5 1.5M6.118 4.5l.347 9h2.07l.347-9zm3.65 0-.347 9h1.696l.347-9zm-5.536 0 .347 9h1.696l-.347-9z" />
                                                        </svg>
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="form-group mb-3 col-md-4">
                            <label for="forcaPlanoAcao" class="form-label">Força do Plano de Ação</label>
                            <select v-model="forcaPlanoAcao" class="form-control" :class="{ 'border-danger': camposInvalidos.forcaPlanoAcao }" id="forcaPlanoAcao">
                                <option disabled value="">Selecione:</option>
                                <option>Fraco</option>
                                <option>Médio</option>
                                <option>Forte</option>
                            </select>
                        </div>
                        <div class="form-group mb-3 col-md-4">
                            <label for="resultadoPlanoAcao" class="form-label">Resultado do Plano de Ação</label>
                            <select v-model="resultadoPlanoAcao" class="form-control" :class="{ 'border-danger': camposInvalidos.resultadoPlanoAcao }" id="resultadoPlanoAcao">
                                <option disabled value="">Selecione:</option>
                                <option>Efetivo</option>
                                <option>Não efetivo</option>
                            </select>
                        </div>
                        <div class="form-group mb-3 col-md-4">
                            <label for="respostaAoRisco" class="form-label">Resposta ao Risco</label>
                            <select v-model="respostaAoRisco" class="form-control" :class="{ 'border-danger': camposInvalidos.respostaAoRisco }" id="respostaAoRisco">
                                <option disabled value="">Selecione:</option>
                                <option>Aceitar</option>
                                <option>Mitigar</option>
                                <option>Transferir</option>
                                <option>Evitar</option>
                            </select>
                        </div>
                    </div>
                    <button class="btn btn-primary w-100" @click="salvarRisco">
                        Salvar
                    </button>
                </div>

                <button class="btn btn-md btn-icon btn-pill btn-white shadow position-absolute top-0 end-0 mt-n3 me-n3"
                        @click="fecharModal"
                        aria-label="Fechar">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
                        <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
                    </svg>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    import { urlApi, avisoErro, avisoToast } from '@/config/global'
    import axios from 'axios'

    export default {
        props: {
            risco: {
                type: Object,
                default: null
            },
            idMatriz: {
                type: Number,
                default: null
            },
        },

        data() {
            return {
                categorias: [],
                categoriaSelecionada: "",
                tituloRisco: "",
                descricaoRisco: "",
                escalas: [],
                idProb: "",
                idQuali: "",
                idQuanti: "",
                prob: "",
                quali: "",
                quanti: "",
                causaConseq: null,
                novaCausaConseq: "",
                tipoCausaConseq: "CA",
                causasConsequenciasCriadas: [],
                editandoIndex: null,
                editandoItem: null,
                editandoTipo: '',
                editandoDescricao: '',
                forcaPlanoAcao: "",
                resultadoPlanoAcao: "",
                respostaAoRisco: "",
                camposInvalidos: {
                    categoriaSelecionada: false,
                    tituloRisco: false,
                    prob: false,
                    quali: false,
                    quanti: false
                }


            }
        },

        watch: {
            risco: {
                immediate: true,
                handler(novoRisco) {
                    if (novoRisco) {
                        this.categoriaSelecionada = novoRisco.idRiscoCategoria || "";
                        this.tituloRisco = novoRisco.dsTitulo || "";
                        this.descricaoRisco = novoRisco.dsRisco || "";
                        this.idProb = novoRisco.idEscalaProbabilidade || "";
                        this.idQuali = novoRisco.idEscalaAnaliseQualitativa || "";
                        this.idQuanti = novoRisco.idEscalaAnaliseQuantitativa || "";
                        this.forcaPlanoAcao = novoRisco.forcaPlanoAcao || "";
                        this.resultadoPlanoAcao = novoRisco.resultadoPlanoAcao || "";
                        this.respostaAoRisco = novoRisco.respostaAoRisco || "";


                        this.getEscalas();
                        if (novoRisco.idRisco) {
                            this.getCausaConsequencia(novoRisco.idRisco);
                        }
                    } else {
                        this.categoriaSelecionada = "";
                        this.tituloRisco = "";
                        this.descricaoRisco = "";
                        this.getEscalas();
                    }
                }
            }
        },

        mounted() {
            this.getCategorias();

        },

        computed: {
            opcoesProbabilidade() {
                return this.escalas.filter(e => e.idEscala === this.idProb || e.idEscalaProbabilidade === this.idProb || e.nmEscala);
            },
            opcoesQualitativa() {
                return this.escalas.filter(e => e.idEscala === this.idQuali || e.idEscalaAnaliseQualitativa === this.idQuali || e.nmEscala);
            },
            opcoesQuantitativa() {
                return this.escalas.filter(e => e.idEscala === this.idQuanti || e.idEscalaAnaliseQuantitativa === this.idQuanti || e.nmEscala);
            },
            todasCausasConsequencias() {
                return [...(this.causaConseq || []), ...this.causasConsequenciasCriadas];
            }
        },

        methods: {
            getCategorias() {
                axios.get(`${urlApi}/GerenciamentoRisco/GetCategorias`)
                    .then(res => {
                        if (res.data.success) {
                            this.categorias = res.data.data.rows || [];

                            if (this.risco && this.risco.idRiscoCategoria) {
                                this.categoriaSelecionada = this.risco.idRiscoCategoria;
                            }
                        } else {
                            avisoErro("Erro ao buscar registro de categorias.");
                        }
                    })
                    .catch(() => {
                        avisoErro("Erro na requisição das categorias.");
                    });
            },

            getEscalas() {
                axios.get(`${urlApi}/GerenciamentoRisco/GetEscalas`, {
                    params: {
                        idEscalaProbabilidade: this.idProb || 0,
                        idEscalaAnaliseQualitativa: this.idQuali || 0,
                        idEscalaAnaliseQuantitativa: this.idQuanti || 0
                    }
                })
                    .then(res => {
                        if (res.data.success) {
                            const data = res.data.data;
                            this.escalas = data.escalas || [];

                            this.prob = data.probabilidade?.idEscala || "";
                            this.quali = data.qualitativa?.idEscala || "";
                            this.quanti = data.quantitativa?.idEscala || "";
                        } else {
                            avisoErro("Erro ao buscar escalas.");
                        }
                    })
                    .catch(() => {
                        avisoErro("Erro na requisição das escalas.");
                        avisoToast("Erro na requisição das escalas.");
                    });
            },

            getCausaConsequencia(idRisco) {
                axios.get(`${urlApi}/GerenciamentoRisco/GetCausaConseq`, {
                    params: { idRisco }
                })
                    .then(res => {
                        if (res.data.success) {
                            this.causaConseq = res.data.data.causaConseq;
                        } else {
                            avisoErro("Erro ao buscar causa e consequência.");
                        }
                    })
                    .catch(err => {
                        avisoErro("Erro na requisição de causa e consequência.");
                        avisoToast("Erro na requisição de causa e consequência.");
                        console.error(err);
                    });
            },

            adicionarCausaConseq() {
                if (!this.novaCausaConseq.trim()) return;

                this.causasConsequenciasCriadas.push({
                    tpRiscoCausaConsequencia: this.tipoCausaConseq,
                    nmRiscoCausaConsequencia: this.novaCausaConseq.trim()
                });

                this.novaCausaConseq = "";
                this.tipoCausaConseq = "CA";
            },

            editarCausaConseq(index) {
                const item = this.todasCausasConsequencias[index];
                this.editandoIndex = index;
                this.editandoItem = item;
                this.editandoTipo = item.tpRiscoCausaConsequencia;
                this.editandoDescricao = item.nmRiscoCausaConsequencia;
            },

            salvarEdicao(index) {
                if (!this.editandoDescricao.trim()) return;

                const offset = this.causaConseq ? this.causaConseq.length : 0;
                const isNovo = index >= offset;

                const novoItem = {
                    tpRiscoCausaConsequencia: this.editandoTipo,
                    nmRiscoCausaConsequencia: this.editandoDescricao.trim()
                };

                if (isNovo) {
                    this.causasConsequenciasCriadas.splice(index - offset, 1, novoItem);
                } else {
                    this.causaConseq.splice(index, 1, {
                        ...this.causaConseq[index],
                        ...novoItem
                    });
                }

                this.editandoIndex = null;
                this.editandoItem = null;
                this.editandoTipo = '';
                this.editandoDescricao = '';
            },

            removerCausaConseq(index) {
                const offset = this.causaConseq?.length || 0;

                if (index < offset) {
                    this.causaConseq.splice(index, 1);
                } else {
                    this.causasConsequenciasCriadas.splice(index - offset, 1);
                }
                if (this.editandoIndex === index) {
                    this.editandoIndex = null;
                    this.editandoItem = null;
                    this.editandoTipo = '';
                    this.editandoDescricao = '';
                }
            },

            async salvarRisco() {
                if (!this.validarCamposObrigatorios()) return;

                const payload = {
                    DadosRisco: {
                        idRisco: this.risco?.idRisco || 0,
                        idRiscoCategoria: this.categoriaSelecionada,
                        idMatriz: this.idMatriz,
                        idEscalaProbabilidade: this.prob,
                        idEscalaAnaliseQualitativa: this.quali,
                        idEscalaAnaliseQuantitativa: this.quanti,
                        dsTitulo: this.tituloRisco,
                        dsRisco: this.descricaoRisco,
                        cdRisco: this.risco?.cdRisco || 0,
                        forcaPlanoAcao: this.forcaPlanoAcao,
                        resultadoPlanoAcao: this.resultadoPlanoAcao,
                        respostaAoRisco: this.respostaAoRisco
                    },
                    CausasConsequencias: this.todasCausasConsequencias.map(c => ({
                        idRiscoCausaConsequencia: c.idRiscoCausaConsequencia || 0,
                        tpRiscoCausaConsequencia: c.tpRiscoCausaConsequencia,
                        nmRiscoCausaConsequencia: c.nmRiscoCausaConsequencia
                    }))
                };

                try {
                    const res = await axios.post(`${urlApi}/GerenciamentoRisco/Post`, payload);

                    if (res.data.success) {
                        avisoToast("Risco salvo com sucesso!");
                        this.$emit('salvoComSucesso');
                        this.fecharModal();
                    } else {
                        avisoErro(res.data.msg || "Erro ao salvar o risco.");
                    }
                } catch (err) {
                    console.error(err);
                    avisoErro("Erro na requisição ao salvar o risco.");
                }
            },

            validarCamposObrigatorios() {
                const campos = this.camposInvalidos;

                campos.categoriaSelecionada = !this.categoriaSelecionada;
                campos.tituloRisco = !this.tituloRisco.trim();
                campos.prob = !this.prob;
                campos.quali = !this.quali;
                campos.quanti = !this.quanti;
                campos.forcaPlanoAcao = !this.forcaPlanoAcao,
                campos.resultadoPlanoAcao = !this.resultadoPlanoAcao,
                campos.respostaAoRisco = !this.respostaAoRisco


                const invalido = Object.values(campos).some(v => v);
                if (invalido) {
                    avisoErro("Preencha todos os campos obrigatórios.");
                }

                return !invalido;
            },

            fecharModal() {
                const modalEl = document.getElementById('ModalRisco');
                if (modalEl) {
                    const modal = window.bootstrap.Modal.getInstance(modalEl);
                    modal.hide();
                }

                this.$emit('fechado');
            }
        }
    }
</script>


<style scoped>
    .modal-dialog-centered {
        max-width: 65vw !important;
        width: 65vw !important;
    }

    .modal-risco {
        border-radius: 18px;
        background: linear-gradient(135deg, #ffffff 0%, #f7f9fc 100%);
        box-shadow: 0 18px 40px rgba(15, 23, 42, 0.12);
        position: relative;
    }

    .modal-risco-body {
        padding: 2rem 2.25rem;
        border-radius: 18px;
    }

    @media (max-width: 768px) {
        .modal-risco-body {
            padding: 1.5rem;
        }
    }

    .modal-risco-title {
        font-weight: 700;
        margin-bottom: 0.25rem;
        background: linear-gradient(135deg, #2563EB 0%, #22c55e 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
        letter-spacing: -0.3px;
    }

    .modal-risco-title i {
        font-size: 1.45rem;
        background: inherit;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
        filter: drop-shadow(0 4px 14px rgba(37, 99, 235, 0.25));
    }

    .modal-risco-divider {
        border: 0;
        height: 2px;
        background: linear-gradient(90deg, rgba(37, 99, 235, 0), rgba(37, 99, 235, 0.4), rgba(37, 99, 235, 0));
        opacity: 1;
        margin-top: 0.75rem;
        margin-bottom: 1.5rem;
    }

    .modal-risco .form-label {
        font-weight: 600;
        color: #1f2937;
    }

    .modal-risco .form-control {
        border-radius: 10px;
        border: 1px solid #d0d5dd;
        box-shadow: none;
        transition: border-color 0.2s ease, box-shadow 0.2s ease;
    }

    .modal-risco .form-control:focus {
        border-color: #2563eb;
        box-shadow: 0 0 0 0.2rem rgba(37, 99, 235, 0.15);
    }

    .modal-risco .btn-group .btn {
        border-radius: 999px;
    }

    .modal-risco .btn-success {
        background: linear-gradient(135deg, #22c55e 0%, #16a34a 100%);
        border: none;
    }

    .modal-risco .btn-primary {
        background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
        border: none;
    }

    .modal-risco .btn-primary,
    .modal-risco .btn-success {
        border-radius: 10px;
    }

    .modal-risco .btn-primary:hover,
    .modal-risco .btn-success:hover {
        filter: brightness(1.02);
    }

    .modal-risco .btn-group .btn-outline-secondary {
        border-color: #d0d5dd;
    }

    .modal-risco .btn-group .btn-outline-secondary:hover {
        background-color: rgba(37, 99, 235, 0.08);
        border-color: #2563eb;
        color: #2563eb;
    }

    .modal-risco .table-wrapper {
        border-radius: 12px;
    }

    .btn-acao {
        display: inline-flex;
        align-items: center;
        gap: 0.4rem;
        border: none;
        border-radius: 9px;
        padding: 0.45rem 0.95rem;
        font-size: 0.9rem;
        font-weight: 600;
        color: #ffffff;
        transition: transform 0.2s ease, box-shadow 0.2s ease, filter 0.2s ease;
    }

    .btn-acao svg {
        transition: transform 0.2s ease;
    }

    .btn-acao:hover {
        transform: translateY(-1px);
        filter: brightness(1.05);
    }

    .btn-acao:hover svg {
        transform: scale(1.05);
    }

    .btn-acao-primary {
        background: linear-gradient(135deg, #2563EB 0%, #1d4ed8 100%);
        box-shadow: 0 10px 22px rgba(37, 99, 235, 0.2);
    }

    .btn-acao-danger {
        background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
        box-shadow: 0 10px 22px rgba(220, 38, 38, 0.22);
    }

    .btn-acao-success {
        background: linear-gradient(135deg, #22c55e 0%, #16a34a 100%);
        box-shadow: 0 10px 22px rgba(34, 197, 94, 0.2);
    }

    [data-bs-theme="dark"] .modal-risco {
        background: linear-gradient(135deg, #111827 0%, #1f2937 100%);
        box-shadow: 0 18px 40px rgba(0, 0, 0, 0.45);
        border: 1px solid rgba(71, 85, 105, 0.45);
    }

    [data-bs-theme="dark"] .modal-risco .form-control {
        border-color: rgba(71, 85, 105, 0.65);
        background-color: rgba(17, 24, 39, 0.85);
        color: #e2e8f0;
    }

    [data-bs-theme="dark"] .modal-risco .form-control:focus {
        border-color: #3b82f6;
        box-shadow: 0 0 0 0.2rem rgba(59, 130, 246, 0.2);
    }

    [data-bs-theme="dark"] .modal-risco-title {
        -webkit-text-fill-color: currentColor;
        color: #e0f2fe;
    }

    [data-bs-theme="dark"] .modal-risco-title i {
        color: #38bdf8;
        -webkit-text-fill-color: currentColor;
        background: none;
    }

    [data-bs-theme="dark"] .modal-risco-divider {
        background: linear-gradient(90deg, rgba(59, 130, 246, 0), rgba(59, 130, 246, 0.5), rgba(59, 130, 246, 0));
    }

    [data-bs-theme="dark"] .modal-risco .form-label {
        color: #e2e8f0;
    }

    [data-bs-theme="dark"] .btn-acao-primary {
        box-shadow: 0 12px 28px rgba(37, 99, 235, 0.35);
    }

    [data-bs-theme="dark"] .btn-acao-danger {
        box-shadow: 0 12px 28px rgba(248, 113, 113, 0.28);
    }

    [data-bs-theme="dark"] .btn-acao-success {
        box-shadow: 0 12px 28px rgba(34, 197, 94, 0.3);
    }

    .table-container {
        display: flex;
        justify-content: center;
        padding-top: 32px;
        padding-bottom: 0px;
        padding-left: 16px;
        padding-right: 16px;
    }

    .table-wrapper {
        width: 100%;
        max-height: 222px;
        padding: 0 10px;
        margin: 0 auto;
        margin-top: -25px;
        overflow-x: auto;
    }

    .custom-table {
        width: 100%;
        border: 1px solid #e5e7eb;
        border-radius: 8px;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
        border-collapse: collapse;
    }

        .custom-table th,
        .custom-table td {
            padding: 12px 16px;
            text-align: left;
            border-bottom: 1px solid #e5e7eb;
        }

        .custom-table td {
            font-family: 'Segoe UI', 'Roboto', 'Helvetica Neue', sans-serif;
            font-size: 15px;
        }

        .custom-table th {
            font-weight: 600;
            font-family: 'Segoe UI', 'Roboto', 'Helvetica Neue', sans-serif;
            font-size: 16px;
            font-weight: bold;
        }

        .custom-table tbody tr:hover {
            background-color: #F5F5F5;
        }
    [data-bs-theme="dark"] .custom-table tbody tr:hover {
        background-color: #1f2937;
        color: #2563EB;
    }

    .btn-outline-danger,
    .btn-outline-primary,
    .btn-outline-success {
        padding: 7px 7px;
        border-radius: 6px;
        font-weight: 600;
        font-size: 14px;
        cursor: pointer;
        transition: background-color 0.2s ease-in-out, color 0.2s ease-in-out;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        height: 32px;
        line-height: 1;
        gap: 6px;
        margin-right: 6px;
    }

    th .btn-icon {
        padding: 0;
        height: auto;
        display: flex;
        justify-content: center;
        align-items: center;
    }

        th .btn-icon svg {
            display: block;
        }

    .border-danger {
        border-color: #E8B6C1 !important;
        box-shadow: 0 0 0 0.2rem rgba(196, 104, 110, 0.25);
    }
</style>
